import { useTranslation } from 'react-i18next';

import { Button } from 'libs/ui';
import { InputUncontrolled } from './input-uncontrolled';
import { Label } from './label';
import { Control } from './control.styled';

export const ColsControl = (props) => {
  const { value, onChange, minCols, maxCols } = props;
  const { t } = useTranslation();

  const minus = () => {
    let out = value;
    if (out > minCols) {
      out--;
      onChange(out);
    }
  };

  const plus = () => {
    let out = value;
    if (out < maxCols) {
      out++;
      onChange(out);
    }
  };

  const change = (val) => {
    onChange(val);
  };

  return (
    <Control>
      <Label>{t('forms.Ширина билета')}:</Label>
      <Button size="small" $square onClick={minus}>
        -
      </Button>
      <InputUncontrolled placeholder="50" value={value} onChange={change} asNumber minValue={minCols} maxValue={maxCols} width={'3.6ch'} />
      <Button size="small" $square onClick={plus}>
        +
      </Button>
    </Control>
  );
};
